export default {
  SUBSCRIPTION_URL:
    'wss://api.thegraph.com/subgraphs/name/aave/protocol-multy-raw',
  URL: 'https://api.thegraph.com/subgraphs/name/aave/protocol-multy-raw',
  POOL_ID: '0x24a42fd28c976a61df5d00d0599c34c4f90748c8'
};
